module.exports = __webpack_public_path__ + "img/turk-nippon-sigorta.29f20e7d.png";